import React from "react";
import Logo from "./Logo";

const LINKS = [
  { id: "about", label: "About" },
  { id: "capabilities", label: "Capabilities" },
  { id: "bandera", label: "Bandera Oil Tools" },
  { id: "team", label: "Team" },
  { id: "contact", label: "Contact" },
];

export default function Footer() {
  const go = (e, id) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative border-t border-white/10 bg-ink-900">
      <div className="mx-auto max-w-shell px-6 py-16 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-6">
            <Logo height={52} />
            <p className="mt-7 max-w-lg text-sm text-steel-400">
              ASL is accepted and approved to provide Wellbore Intervention
              Specialists, Rental Tools and associated equipment to the local and
              international operators in the Region. We have implemented our
              Quality, Health, Safety and Environment Management System (QHSEMS)
              to help us develop a safe culture to prevent accidents on our
              facilities and worksites.
            </p>
          </div>

          <div className="lg:col-span-3">
            <p className="mb-5 font-mono text-[11px] uppercase tracking-kicker text-flame-500">
              Navigate
            </p>
            <ul className="space-y-3">
              {LINKS.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    onClick={(e) => go(e, link.id)}
                    className="text-sm text-steel-400 transition-colors hover:text-flame-500"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="mb-5 font-mono text-[11px] uppercase tracking-kicker text-flame-500">
              Get in touch
            </p>
            <address className="space-y-3 text-sm not-italic text-steel-400">
              <p className="leading-relaxed">
                Lot #2 Otaheite Industrial Park,
                <br />
                South Oropouche, Trinidad, West Indies
              </p>
              <p>
                <a
                  href="mailto:info@anfieldtt.com"
                  className="transition-colors hover:text-flame-500"
                >
                  info@anfieldtt.com
                </a>
              </p>
              <p>
                <a
                  href="tel:8684748903"
                  className="transition-colors hover:text-flame-500"
                >
                  868 474 8903
                </a>
              </p>
              <p>
                <a
                  href="tel:8682721480"
                  className="transition-colors hover:text-flame-500"
                >
                  868 272 1480
                </a>
              </p>
            </address>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-shell flex-col gap-3 px-6 py-6 font-mono text-[11px] uppercase tracking-wide2 text-steel-400 sm:flex-row sm:items-center sm:justify-between lg:px-10">
          <span>
            © {new Date().getFullYear()} Anfield Services Limited
          </span>
          <span>South Oropouche · Trinidad & Tobago</span>
        </div>
      </div>
    </footer>
  );
}
